import React from "react";
import PropTypes from "prop-types";
import Base from "../Base";
import { Input } from "antd";

@autobind
/**
 *
 */
export default class Phone extends Base {
  static propTypes = {
    ...Base.propTypes,
    value: PropTypes.string,
  };

  /**
   *
   * @return {XML}
   * @protected
   */
  get _component() {
    return (
      <Input
        type="tel"
        onChange={(event) => this.props.onChange(app.transform.fa2en(event.target.value))}
      />
    );
  }
}
